import { render, staticRenderFns } from "./SchoolCreate.vue?vue&type=template&id=4c0db75a&"
import script from "./SchoolCreate.js?vue&type=script&lang=js&"
export * from "./SchoolCreate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports